import { configureStore } from '@reduxjs/toolkit';
import { apiSlice } from '../features/API/apiSlice';
import filterReducer from "../features/Filter/filterSlice"

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath] : apiSlice.reducer,
    filter: filterReducer
  },
  middleware: (getDefaultMiddlewares) =>
        getDefaultMiddlewares().concat(apiSlice.middleware),
});
